
<template aspectRatio="2">
  <div>
    <canvas :id="id">
      Your browser does not support the canvas element.
    </canvas>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      require: true,
    },
    hoverPointer: {
      default: false,
    },
    onClick: {
      default: () => () =>{ },
    },
    options: { default: () => { return {}}},
    datasets:{
      default: () => [
        {
          label: 'Pendiente',
          data: [
            {x:1, y: 100},
            {x:2, y: 150},
            {x:3, y: 97},
            {x:4, y: 50},
          ],
          backgroundColor: '#aaaaaa',
          borderColor: '#aaaaaa',
        },
        {
          label: 'Completado',
          data: [
            {x:1, y: 47},
            {x:2, y: 50},
            {x:3, y: 30},
            {x:4, y: 0},
          ],
          backgroundColor: '#454444',
          borderColor: '#454444',
        },
        {
          label: 'Iniciado',
          data: [
            {x:1, y: 30},
            {x:2, y: 50},
            {x:3, y: 25},
            {x:4, y: 25},
          ],
          backgroundColor: '#d99148',
          borderColor: '#d99148',
        },
      ]
    },
    labels:{
      default: () => ['Concentradora', 'NPI & CHO', 'Mina', 'Cátodos']
    }
  },
  data() {
    return {
      StackedBar:'',
    };
  },
  watch: {
    dark_t(val) { this.load() },
    datasets(val) { this.load() },
    mobil(val) {
      this.StackedBar.aspectRatio = ['sm','xs', 'md'].includes(val) ? 1: 2;
    }
  },
  mounted(){ this.load() },
  methods: {
    load(){
      const hover = this.hoverPointer
        ? {
          onHover: function(e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = 'pointer';
            else e.target.style.cursor = 'default';
          }
        }
        : {};
      const {onClick} = this;
      const {options} = this;
      

      var Chart = require('chart.js');
      var ctx = document.getElementById(this.id).getContext('2d');
      if (this.StackedBar.destroy) this.StackedBar.destroy();
      const {getElementAtEvent} = this.StackedBar;
      this.StackedBar = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options:Object.assign({},{options},{onClick:function(e,a) { onClick && onClick(e,a,this.getElementAtEvent(e))}} ,{hover},{
          scales: {
            xAxes: [{
              display: true,
              gridLines: {
                color:this.dark_t?'white':'lightgrey',
              },
              ticks: {
                /* beginAtZero:true, */
                fontColor: this.dark_t?'white':'black',
              },
            }],
            yAxes: [{
              display: true,
              gridLines: {
                color:this.dark_t?'white':'lightgrey',
              },
              ticks: {
                /* beginAtZero:true, */
                fontColor: this.dark_t?'white':'black',
              },
            }],
          },
          legend: {
            labels: {
              fontColor: this.dark_t?'white':'black',
            }
          },
        }),
      });
      this.StackedBar.aspectRatio = ['sm','xs', 'md'].includes(this.$vuetify.breakpoint.name)
        ? 1
        : 2;
    }
  }, // methods
};
</script>
